import { Routes, Route, useLocation  } from "react-router-dom";
import './App.css';
import { useEffect } from "react";

import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import Layout from "./components/Layout";
import Studentlayout from "./components/Studentlayout";
import Hero from './components/Hero';
import About from './components/About';
import Notification from './components/Notification';
import Login from './components/Login';
import Contact from './components/Contact';
import Signup from "./components/Signup";
import SubjectDetail from "./components/SubjectDetail";
import TitleManager from "./components/TitleManager";
import Profile from "./components/Profile";
import PasswordChange from "./components/PasswordChange";
import ForgotPassword from "./components/ForgotPassword";
import Mocktest from "./components/Mocktest";
import Chapterwise from "./components/Chapterwise";
import Chapterquiz from "./components/quizs/Chapterquiz";
import Masterquiz from "./components/quizs/Masterquiz";
import OtpVerification from './components/OtpVerification';
import Enrollments from "./components/Enrollments";
import StudentDashboard from "./components/StudentDashboard";
import Subjects from "./components/Subject";
import Analysis from "./components/Analysis";
import WhatsAppButton from "./components/WhatsAppButton";
import RightPopup from "./components/RightPopup";


import MasterQuizList from "./components/MasterQuizList";
import ChapterQuizList from "./components/ChapterQuizList"; 
import SubscriptionList from "./components/SubscriptionList";
import Announcements from "./components/Announcements";
import Subscription from './components/Subscription';
import ViewResult from './components/ViewResult';
import FinishExam from "./components/FinishExam";
import ViewExplanation from "./components/ViewExplanation";

import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsConditions from "./components/TermsConditions"; 
import CompleteProfile from "./components/CompleteProfile";
import ResetPassword from "./components/ResetPassword";

function App() {

 const location = useLocation();

  useEffect(() => {

        if (window.initTemplate) {
      window.initTemplate();
       }
      

    const script = document.createElement("script");
    script.src = "https://example.com/your-script.js";
    script.async = true;
    document.body.appendChild(script);
  }, [location.pathname]);

  const user = sessionStorage.getItem("user");

return (
  <div className="App">
    <TitleManager /> 
     
    <WhatsAppButton />
<RightPopup />

    <Routes>
      <Route element={<PrivateRoute />}>
        <Route path="/studentdashboard" element={<Studentlayout><StudentDashboard /></Studentlayout>} />
         <Route path="/complete-profile" element={<Studentlayout><CompleteProfile /></Studentlayout>} />
        <Route path="/subjects" element={<Studentlayout><Subjects /></Studentlayout>} />
        <Route path="/analysis" element={<Studentlayout><Analysis /></Studentlayout>} />
        <Route path="/enrollments" element={<Studentlayout><Enrollments /></Studentlayout>} />
        <Route path="/profile" element={<Studentlayout><Profile /></Studentlayout>} />
        <Route path="/profile/password-change" element={<Studentlayout><PasswordChange /></Studentlayout>} />
        <Route path="/view-result/:id" element={<Studentlayout><ViewResult /></Studentlayout>} />
        <Route path="/mocktest/chapterwise/:subjectId" element={<Studentlayout><Chapterwise /></Studentlayout>} />
        <Route path="/mocktest/chapterquiz/:chapterId" element={<Studentlayout><Chapterquiz /></Studentlayout>} />
        <Route path="/subjectdetail/:id" element={<Studentlayout><SubjectDetail /></Studentlayout>} />
      
        <Route path="/view-explanation/:id" element={<Studentlayout><ViewExplanation /></Studentlayout>} />
        <Route path="/masterquizlist" element={<Studentlayout><MasterQuizList /></Studentlayout>} />
        <Route path="/chapterwisequizlist" element={<Studentlayout><ChapterQuizList /></Studentlayout>} />
        <Route path="/subscriptionlist" element={<Studentlayout><SubscriptionList /></Studentlayout>} />
        <Route path="/announcement" element={<Studentlayout><Announcements /></Studentlayout>} />        
        <Route path="/mocktest" element={<Studentlayout><Mocktest /></Studentlayout>} />
        <Route path="/mocktest/masterquiz/:id" element={<Studentlayout><Masterquiz /></Studentlayout>} />
        <Route path="/finish-exam/:id" element={<Studentlayout><FinishExam /></Studentlayout>} />
        <Route path="/finish-exam" element={<FinishExam />} />
      </Route>

      <Route path="/Subscription" element={ user ? (
      <Studentlayout>
        <Subscription />
      </Studentlayout>
    ) : (
      <Layout>
        <Subscription />
      </Layout>
    )} />

      <Route element={<PublicRoute />}>
        <Route path="/" element={<Layout><Hero /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/notification" element={<Layout><Notification /></Layout>} /> 
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/login" element={<Layout><Login /></Layout>} />
        <Route path="/signup" element={<Layout><Signup /></Layout>} />
        <Route path="/forgot-password" element={<Layout><ForgotPassword /></Layout>} />
        <Route path="/forgot-password/:token" element={<Layout><ResetPassword /></Layout>} />
        <Route path="/OtpVerification" element={<Layout><OtpVerification /></Layout>} />
        <Route path="/privacy-policy" element={<Layout><PrivacyPolicy /> </Layout>} />
        <Route path="/terms-conditions" element={<Layout><TermsConditions /> </Layout>} />

      </Route>
    </Routes>
  </div>
);

}

export default App;
